export class State {
    public __classname__: string = 'State';

    public Id: string | null = null;
    public Name: string | null = null;
    public Type: string | null = null;
    public Produce: boolean | null = null;
    public Color: string | null = null;
    public DefaultRouteTo: string | null = null;

    constructor(
        Id: string | null = null,
        Name: string | null = null,
        Type: string | null = null,
        Produce: boolean | null = null,
        Color: string | null = null,
        DefaultRouteTo: string | null = null
    ) {
        this.Id = Id;
        this.Name = Name;
        this.Type = Type;
        this.Produce = Produce;
        this.Color = Color;
        this.DefaultRouteTo = DefaultRouteTo;
    }
}